




















import Proxyable from '@/mixins/proxyable';
import { Quote } from '@/models/quote';
import { PropType } from 'vue';
import { mapActions } from 'vuex';

export default Proxyable.extend({
  data: () => ({
    revisionLoading: false
  }),
  props: {
    item: { type: Object as PropType<Quote> }
  },

  methods: {
    ...mapActions({
      fetchQuoteRevisions: 'quote/fetchQuoteRevisions',
      setLatestRevision: 'quote/setLatestRevision'
    }),

    setRevision(quote: Quote) {
      this.revisionLoading = true;
      if (quote.latest) {
        this.setLatestRevision({
          quoteId: quote.number,
          revisionId: quote.revision
        })
          .then(() => {
            this.$emit('fetchQuoteRevisions', quote.number);
            this.revisionLoading = false;
          })
          .then(() => {
            quote.latest = false;
          });
      }
    }
  }
});
